<template>
  <div>
    <heading>What Next</heading>
    <p class="m-t-8">Thank you for submitting this applicant. We’ve emailed them immediately to confirm their application and to complete registration for HireVibes ...</p>
    <divider />
    <heading>Submitted By</heading>
    <user-row-card class="hoverable" :user="submittedBy" @click="onUserClicked(current.userId)" />
  </div>
</template>
<script>
import Heading from '@/components/general/heading'
import Divider from '@/components/general/divider'
import UserRowCard from '@/components/general/user-row-card'
import {mapState} from 'vuex'

export default {
  components: {Heading, Divider, UserRowCard},
  computed: {
    ...mapState('users', ['user']),
    ...mapState('adminApplications', ['currentJob']),
    submittedBy () {
      return {
        ...this.user,
        location: this.user.locationTitle
      }
    }
  },
  methods: {
    onUserClicked (userId) {
      window.open(`/jobseekers/${userId}`, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/applications/register-apply-success.vue